module.exports = __webpack_public_path__ + "static/data-analytics-2-47bc4c94441565229a3c7c24a55fcbb1.svg";